/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
$(document).on("turbo:load", function () {
  class AnalyticsLessonView {
    constructor() {
      this.bindToggle()
    }

    updateParams(includeBlanks) {
      this.includeBlanks = includeBlanks
      return $("#lesson-views .sorter a").attr("href", (i, href) => {
        return href.replace(
          /include_blank.*?&/g,
          `include_blank=${this.includeBlanks}&`
        )
      })
    }

    bindToggle() {
      return $("#content").on("click", "#include-blank", () => {
        console.log("clicked")
        return this.updateParams($("#include-blank").prop("checked"))
      })
    }
  }

  if ($(".admin").length) {
    return new AnalyticsLessonView()
  }
})
